import React, {PureComponent} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import Button from "@irati/ui/src/Button"
import {greys} from "@irati/ui/src/global/colors"
import {FormattedMessage, injectIntl} from "@irati/utils/lang"
import notify from "@irati/utils/notify"
import {getCurrentPosition as getFallbackPosition} from "@irati/geolocation/src/services/fallbackPosition"
import {getCurrentPosition as getBrowserPosition} from "@irati/geolocation/src/helpers/devicePosition"

import {
  MODES,
  BROWSER_POSITION_WITH_FALLBACK,
  BROWSER_POSITION_WITHOUT_FALLBACK,
  FALLBACK_POSITION
} from "../../constants/currentLocationButton"

const StyledButtonWithIcon = styled(Button)`
  padding: 10px;
`

class CurrentLocationButton extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    positionMode: PropTypes.oneOf(MODES)
  }

  static defaultProps = {
    className: null,
    positionMode: BROWSER_POSITION_WITH_FALLBACK
  }

  constructor(props) {
    super(props)
    this.state = {
      load: null
    }
  }

  getPosition = () => {
    const {positionMode} = this.props
    switch (positionMode) {
      case BROWSER_POSITION_WITH_FALLBACK:
        return getBrowserPosition({useFallback: true})
      case BROWSER_POSITION_WITHOUT_FALLBACK:
        return getBrowserPosition({useFallback: false})
      case FALLBACK_POSITION:
        return getFallbackPosition()
      default:
        return Promise.resolve({latLng: null})
    }
  }

  handleClick = () => {
    const {onClick} = this.props

    const load = this.getPosition()
      .then(({latLng}) => {
        onClick(latLng)
        return latLng
      })
      .catch(({message}) => notify.error({message}, this))

    this.setState({load})
  }

  render() {
    const {className} = this.props
    const {load} = this.state

    return (
      <StyledButtonWithIcon
        className={className}
        onClick={this.handleClick}
        icon="geoArrow"
        size={12}
        load={load}
        color={greys.black}>
        <FormattedMessage id="geolocation.components.map.currentLocationButton.text" />
      </StyledButtonWithIcon>
    )
  }
}

export default injectIntl(CurrentLocationButton)
